export enum Links {
  Snaps = '/snaps',
  Offers = '/offers',
  Queues = '/queues',
  Reports = '/reports',
  Products = '/products',
  NoAccess = '/no-access',
  NotFound  = '/not-found',
  Companies = '/companies',
  Retailers = '/retailers',
  Feedbacks = '/feedbacks',
  FeatureFlag = '/feature-flag',
  Transactions = '/transactions',
  Configuration = '/configuration',
}